export default __webpack_public_path__ + "static/media/Rabi_2021-22.241956ca.webm";